export function formatAddress(str) {
  if (str) {
    return str.substr(0, 5) + "..." + str.substr(-5, 5);
  } else {
    return str;
  }
}
